'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.loadContentsNoLesson = loadContentsNoLesson;
exports.loadContents = loadContents;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'home/CONTENTPAGE/LOAD';
var SUCCESS = 'home/CONTENTPAGE/SUCCESS';
var FAIL = 'home/CONTENTPAGE/FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SUCCESS:
      console.log('yup!!');
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        // accessToken: action.result.accessToken.id,
        data: action.result
      });
    default:
      return state;
  }
}

/*
* Actions
* * * * */

function isLoaded(globalState) {
  return globalState.contentPage && globalState.contentPage.loaded;
}

function loadContentsNoLesson(pnum) {
  console.log("loadContentsNoLesson");
  var offset = (pnum - 1) * 10 + 1;
  var mFilter = {
    skip: offset - 1,
    limit: 10,
    where: {
      active: 1,
      lessonId: 0
    },
    order: "lastUpdated desc"
  };
  console.log('loadContents');
  return {
    types: [LOAD, SUCCESS, FAIL],
    promise: function promise(_ref) {
      var client = _ref.client,
          oneApiClient = _ref.oneApiClient;
      return oneApiClient.get('/contents', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}

function loadContents(pnum) {
  var offset = (pnum - 1) * 10 + 1;
  var mFilter = {
    skip: offset - 1,
    limit: 10,
    where: {
      active: 1
    },
    order: "lastUpdated desc"
  };
  console.log('loadContents');
  return {
    types: [LOAD, SUCCESS, FAIL],
    promise: function promise(_ref2) {
      var client = _ref2.client,
          oneApiClient = _ref2.oneApiClient;
      return oneApiClient.get('/contents', {
        params: {
          filter: (0, _stringify2.default)(mFilter)
        }
      });
    } //
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/contentPage.js
// module id = 387
// module chunks = 0